<script setup>
import { computed } from 'vue'

/**
 * The component's inherited properties.
 */
const props = defineProps({
    /**
     * The given status.
     *
     * @type {String}
     */
    value: {
        type: String,
        required: true,
    },
})

const icon = computed(() => {
    switch (props.value) {
        case 'Pending':
            return 'far fa-circle-question'
        case 'Scheduled':
            return 'far fa-circle-user'
        case 'In-Transit':
            return 'far fa-circle-arrow-right'
        case 'Delivered':
            return 'far fa-circle-check'
        default:
            return ''
    }
})
</script>

<template>
    <v-chip color="primary" size="x-small">
        <template v-slot:prepend>
            <v-icon data-test="status-icon" size="x-small" class="me-1">{{
                icon
            }}</v-icon>
        </template>
        <span class="text-sm" data-test="status-label">{{ value }}</span>
    </v-chip>
</template>
